import * as ServerOperations from "@/Common/Operations/operations.server";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { BaseAction } from "./BaseAction";

class CacheAction extends BaseAction {
    constructor() {
        super();
    }

    public refreshServicesAndLookups(): void {
        var requestData = {
        };

        return this.Execute(ServerOperations.Server.Myle_GetLookups, requestData, SubServerOperations.Administration.RefreshServicesAndLookups);
    }

    public refreshServices(): void {
        var requestData = {
        };

        return this.Execute(ServerOperations.Server.Myle_AdministrationGetEmployees, requestData);
    }

    public refreshLookups(): void {
        var requestData = {
            NoCache: true,
            IsLightDTOsResponse: true
        };

        return this.Execute(ServerOperations.Server.Myle_GetLookups, requestData);
    }
}

export { CacheAction };
